"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.imageFactory = void 0;
const Factory = require("factory.ts");
exports.imageFactory = Factory.Sync.makeFactory({
    image_type: 'logo',
    label: 'logo',
    image_urls: {
        tiny: 'https://example.com/tiny.png',
        small: 'https://example.com/small.png',
        medium_square: 'https://example.com/medium_square.png',
        medium: 'https://example.com/medium.png',
        large_square: 'https://example.com/large_square.png',
        large: 'https://example.com/large.png',
        extra_large: 'https://example.com/extra_large.png',
        print: 'https://example.com/print.png',
        large_uncropped: 'https://example.com/large_uncropped.png',
    }
});
